module.exports = __webpack_public_path__ + "img/new_discussion_bg.63abc1e6.png";